module.exports = __webpack_public_path__ + "img/bg-404.cab29ac7.png";